import { EmployeeRole } from '@/types';
import { OrderQuantityConfig } from '@domain/configuration/types';
import { SUPPLIER_ADMIN_ROLES } from '@domain/access-control/types/employee-roles';

interface MinMaxQuantityEnabledParams {
  employeeRole: EmployeeRole | null;
  orderQuantityConfig: OrderQuantityConfig | null | undefined;
}

// Whether variant pack order min/max quantities apply to the current user
// Enforcement is default behaviour and skipping is a special case
//
// MOQs get _enforced_ if:
// 1. order_quantity_config.min_max_quantity_v2_enabled must be true
// 2a. user is _not_ a Pepper or supplier admin
// 2b. user _is_ an admin, but enforce_for_supplier_admins is still true
export const isMinMaxQuantityEnabled = ({
  employeeRole,
  orderQuantityConfig,
}: MinMaxQuantityEnabledParams): boolean => {
  // no enforcement if feature isn't enabled
  if (!orderQuantityConfig?.min_max_quantity_v2_enabled) {
    return false;
  }

  const isSupplierAdmin =
    employeeRole !== null && SUPPLIER_ADMIN_ROLES.has(employeeRole);

  // if not admin, then always enforced
  if (!isSupplierAdmin) {
    return true;
  }

  // if admin, then 'enforce_for_supplier_admins' must be explicitly set to 'false' to skip enforcement (falsey doesn't count)
  return orderQuantityConfig.enforce_for_supplier_admins !== false;
};
